import { OPENED_CONTENT_WIDTH as openedDrawerWidth } from 'layout/MainLayout/components/Sidebar/constants';
import { openedMixin } from 'layout/MainLayout/components/Sidebar/utils';

import type { CSSObject, Theme } from '@mui/material/styles';

export const openedListItemMixin = (theme: Theme): CSSObject => ({
  width: openedDrawerWidth,
  height: 36,
  marginBottom: theme.spacing(2),
  ...openedMixin({ theme }),
});
